// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInExistingAccountStyles } from "@stoneage/Overrides/Widgets/SignIn/SignInExistingAccount";
import { fontConfig } from "@stoneage/XDL/constants";
import { xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

signInExistingAccountStyles.container = {
    css: css`
        max-width: 450px;
        padding-right: 16px;
        margin: 0 auto;
    `,
};

signInExistingAccountStyles.icon = {
    css: css`
        &&& {
            background: transparent;
        }
    `,
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h3",
    css: css`
        text-align: center;
    `,
};

signInExistingAccountStyles.signInExistingAccountDescription = {
    ...fontConfig.regular,
    css: css`
        display: block;
        width: 100%;
        margin-bottom: 16px;
        text-align: center;

        ${xScreen("lt", "sm")} {
            padding: 0;
        }
    `,
};

signInExistingAccountStyles.passwordGridItem = {
    width: 12,
    css: css`
        position: relative;
        flex-direction: column;
        gap: 10px;
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        ...fontConfig.xxSmall,
        weight: fontConfig.weight.bold,
    },
    css: css`
        position: absolute;
        top: 10px;
        right: 10px;
    `,
};

signInExistingAccountStyles.signInButton = {
    mergeCss: true,
    css: css`
        width: 100%;
    `,
};
